export default __webpack_public_path__ + "static/media/benefit_5.21b8c7f8.png";